module.exports = __webpack_public_path__ + "static/media/menu.c275e518.svg";